import { render, staticRenderFns } from "./CustomerTable.vue?vue&type=template&id=3c099874"
import script from "./CustomerTable.vue?vue&type=script&lang=ts"
export * from "./CustomerTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports